module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "forgot-password"
    }
  }, [_c('form', [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? [_c('h1', [_vm._v("Recover your Password")]), _vm._v(" "), (!_vm.showConfirmation) ? [(_vm.formErrors.length > 0) ? _c('div', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.formErrors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  })) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.formErrors = []
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendRecoveryLink($event)
      }
    }
  }, [_vm._v("Send Recovery Link")])] : _vm._e(), _vm._v(" "), (_vm.showConfirmation) ? [_c('p', [_vm._v("An email has been sent to " + _vm._s(_vm.email) + ". Wait a few minutes and check your spam folder.")])] : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27bb92f1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Login/ForgotPassword.vue
// module id = 839
// module chunks = 2